import React from 'react';

const CustomCodePage = () => {
    return (
        <div>
            
        </div>
    );
}

export default CustomCodePage;
